export const es = {
  language: {
    label: 'Idioma',
    es: 'ES',
    en: 'EN',
    switchTo: 'Switch to English',
  },
  nav: {
    services: 'Servicios',
    portfolio: 'Portafolio',
    about: 'Nosotros',
    reviews: 'Reseñas',
    cta: 'EMPIEZA HOY →',
    openMenu: 'Abrir menú',
    closeMenu: 'Cerrar menú',
  },
  hero: {
    imageAlt: 'Website profesional para contractors mostrado en laptop y celular',
    titleA: 'Haz Que Tu Negocio Se Vea',
    titleHighlight: 'Tan Profesional Como Tu Trabajo.',
    titleSub: 'Un Website Que Te Trae Clientes.',
    subtitleBefore: 'Mira tu website antes de pagarlo completo. Tu demo por solo',
    subtitlePrice: '$25',
    subtitleAfter: '— si te gusta, pagas el resto. Si no, ahí queda.',
    ctaWhatsapp: 'ESCRÍBENOS POR WHATSAPP →',
    ctaWork: 'Ver Nuestro Trabajo',
    badges: [
      'Diseño Premium',
      'Listo en 72 Horas',
      'Satisfacción Garantizada',
      'Demo Por Solo $25',
    ],
  },
  socialProof: {
    label: 'TRABAJAMOS CON CONTRACTORS DE:',
    types: [
      'Roofing',
      'Landscaping',
      'Tree Service',
      'Construcción',
      'Pressure Washing',
      'Junk Removal',
      'HVAC',
      'Plomería',
    ],
  },
  problem: {
    titleA: 'Haces Un Trabajo Increíble.',
    titleHighlight: 'Pero Tu Presencia Online Te Cuesta Clientes.',
    p1a: 'Antes de llamarte, los clientes te buscan en Google. Juzgan tu profesionalismo en menos de',
    p1strong: '7 segundos',
    p1b: '.',
    p2a: 'Y si lo que ven no refleja la calidad de tu trabajo,',
    p2strong: 'llaman a alguien más.',
    p3: 'No porque trabajen mejor que tú. Sino porque se ven más profesionales online.',
    imageAlt:
      'Comparación de un website de contractor desactualizado versus uno profesional',
    before: 'Antes',
    after: 'Después',
    painPoints: [
      {
        problem: 'Diseño desactualizado',
        cost: 'Cero confianza inicial',
      },
      {
        problem: 'Template genérico',
        cost: 'Te ves amateur',
      },
      {
        problem: 'No apareces en Google',
        cost: 'Competencia gana',
      },
    ],
    closing1:
      'Un homeowner con un proyecto de $10,000 acaba de contratar a tu competencia.',
    closing2: 'Porque su website se veía más confiable.',
    closing3: 'Eso termina hoy.',
  },
  mechanism: {
    badge: 'La Solución',
    title: 'Presentamos The Professional Presence System',
    subtitle:
      'La solución digital completa creada exclusivamente para contractors locales que quieren verse tan profesionales como trabajan — por un solo pago accesible y sin complicaciones.',
    colFeature: 'Característica',
    colOther: 'Otras Opciones',
    colUs: 'AS Elite Contractor',
    comparisons: [
      {
        feature: 'Enfoque',
        other: 'Templates genéricos para cualquier negocio',
        us: 'Construido exclusivamente para contractors',
      },
      {
        feature: 'Estrategia',
        other: 'Solo enfocado en diseño',
        us: 'Diseño + estrategia de conversión',
      },
      {
        feature: 'Riesgo',
        other: 'Pagas todo por adelantado sin ver nada',
        us: 'Demo por $25 — pagas el resto solo si te gusta',
      },
      {
        feature: 'Tiempo',
        other: 'Semanas o meses para lanzar',
        us: 'Listo en menos de 72 horas',
      },
      {
        feature: 'Visibilidad',
        other: 'Sin estrategia de SEO',
        us: 'SEO local incluido desde el primer día',
      },
      {
        feature: 'Soporte',
        other: 'Sin soporte después del lanzamiento',
        us: 'Mantenimiento opcional disponible',
      },
      {
        feature: 'Resultados',
        other: 'Se ve bien pero no convierte',
        us: 'Construido para convertir visitas en llamadas',
      },
    ],
  },
  portfolio: {
    badge: 'Nuestro Trabajo',
    title: 'Websites Que',
    titleHighlight: 'Hemos Construido',
    subtitle:
      'Diseños premium que convierten visitantes en clientes — listos en menos de 72 horas.',
    cta: 'Quiero El Mío →',
    websiteAltPrefix: 'Website de',
    trades: {
      junkRemoval: 'Junk Removal',
      construction: 'Construcción',
      landscaping: 'Landscaping',
      treeService: 'Tree Service',
      irrigation: 'Irrigación',
    },
  },
  google: {
    badge: 'Servicio Aparte · Opcional',
    title: 'Manejo de Tu Perfil de',
    titleHighlight: 'Google Business',
    descA: 'Este servicio es',
    descIndependent: 'independiente del website',
    descB: 'y tiene un costo extra de',
    descPrice: '$30/mes',
    descC:
      '. Nosotros nos encargamos de manejarlo para que aparezcas primero en tu zona y consigas más clientes — sin pagar publicidad.',
    noteLabel: 'Nota:',
    noteText:
      'el perfil lo crea el cliente. Nosotros solo nos encargamos de manejarlo y optimizarlo.',
    included: [
      'Subimos fotos de tus trabajos',
      'Contestamos tus reseñas',
      'Optimización para salir primero',
    ],
    optimized: 'Optimizado',
    profileAltPrefix: 'Perfil de Google de',
    actions: ['Cómo llegar', 'Guardar', 'Llamar', 'Sitio web'],
  },
  pricing: {
    title: 'Todo Lo Que Necesitas.',
    titleHighlight: 'Un Solo Pago.',
    badge: 'Oferta Principal',
    imageAlt:
      'Ejemplo de website profesional para contratistas mostrado en una laptop',
    cardTitle: 'DEMO DE TU WEBSITE',
    price: '$25',
    priceUnit: 'por tu demo',
    noteA: 'Si te gusta, pagas los',
    noteRest: '$225 restantes',
    noteB: 'y lo lanzamos (total $250). Si no te gusta,',
    noteBold: 'solo se te cobra el demo',
    noteC: '. Y la verdad, estamos seguros de que te va a encantar.',
    features: [
      'Empieza con solo $25 — sin riesgo',
      'Ves tu website real antes de pagar más',
      'Si no te gusta, no pagas nada más',
      'Sin contratos ni mensualidades',
    ],
    cta: 'QUIERO MI DEMO POR $25',
    paymentTitle: 'Métodos de pago seguros',
    zelle: 'Zelle',
    card: 'Tarjeta',
    viaStripe: 'vía Stripe',
    domainNote:
      'El dominio está incluido por 1 año. Después del primer año se renueva por separado con un costo anual.',
    featureCards: [
      {
        title: 'Diseño Premium',
        desc: 'Mobile-first y optimizado',
      },
      {
        title: 'Credibilidad',
        desc: 'Reseñas y galería de proyectos',
      },
      {
        title: 'Crecimiento',
        desc: 'SEO Local y Google Business',
      },
    ],
    optional: 'Opcional',
    maintenance: 'Mantenimiento',
    maintenanceDesc: 'Actualizaciones y soporte',
    perMonth: '/ mes',
    otherTitle: '¿Tienes otro tipo de negocio?',
    otherDesc:
      'También creamos websites para cualquier negocio. Pregúntanos sin compromiso.',
    otherCta: 'Pregúntanos',
  },
  process: {
    title: 'Listo En Menos De 72 Horas.',
    titleHighlight: 'Así De Simple.',
    steps: [
      {
        title: 'Contacto',
        desc: 'Escríbenos por WhatsApp',
      },
      {
        title: 'Información',
        desc: 'Envíanos tus datos y fotos',
      },
      {
        title: 'Demo',
        desc: 'Solo $25 para empezar',
      },
      {
        title: 'Construcción',
        desc: 'Diseñamos tu website',
      },
      {
        title: 'Decides',
        desc: 'Te gusta, pagas el resto',
      },
      {
        title: 'Lanzamiento',
        desc: 'Tu página en vivo',
      },
    ],
  },
  story: {
    title: 'Construimos Esto Para Contractors Que',
    titleHighlight: 'Merecen Más',
    p1: 'Vimos a excelentes contractors perder trabajos contra competidores mediocres, simplemente porque su presencia digital se veía amateur.',
    p2a: 'Muchos pensaban que un website profesional costaba miles de dólares y meses de espera.',
    p2strong: 'No tiene que ser así.',
    missionTitle: 'Nuestra Misión',
    missionQuote:
      'Darle a los contractors la presencia online premium que merecen — a un precio accesible, en tiempo récord, sin complicaciones.',
    bullets: [
      'Demo de tu website por solo $25',
      'Listo en menos de 72 horas',
      'Sin mensualidades obligatorias',
      'Sin contratos largos ni sorpresas',
    ],
  },
  testimonials: {
    title: 'Los Contractors Que Dieron El Paso',
    titleHighlight: 'No Se Arrepienten',
    reviewCount: '· +120 reseñas',
    verified: 'Cliente verificado de AS Elite Contractor',
    prevLabel: 'Reseña anterior',
    nextLabel: 'Siguiente reseña',
    dotLabelPrefix: 'Ir a la reseña',
    items: [
      {
        quote:
          'La verdad no esperaba mucho, pero en menos de 3 días ya tenía mi página corriendo. La primera semana me llegaron 4 llamadas de Google. Por $250 fue la mejor decisión que tomé para mi negocio.',
        author: 'Marcus Thompson',
        role: 'Tree Service',
        location: 'Austin, TX',
        timeAgo: 'hace 2 semanas',
      },
      {
        quote:
          'Mi trabajo siempre fue bueno pero mi página vieja me daba pena enseñarla. Ahora los clientes llegan con más confianza y hasta me preguntan menos por el precio. Muy contento con el resultado.',
        author: 'Roberto Mendoza',
        role: 'Roofing & Repairs',
        location: 'Houston, TX',
        timeAgo: 'hace 1 mes',
      },
      {
        quote:
          'Pensé que un website así iba a costar miles. Pagué $250 y en 72 horas tenía algo que se ve mejor que el de mi competencia que tardó meses. La comunicación por WhatsApp fue rapidísima.',
        author: 'Carlos Díaz',
        role: 'General Contractor',
        location: 'Phoenix, AZ',
        timeAgo: 'hace 3 semanas',
      },
      {
        quote:
          'El plan de $30 al mes vale cada centavo. Cada vez que termino un proyecto nuevo les mando las fotos y me las suben el mismo día. Atención de primera, los recomiendo 100%.',
        author: 'James Rivera',
        role: 'Landscaping',
        location: 'Dallas, TX',
        timeAgo: 'hace 5 días',
      },
      {
        quote:
          'Lo que más me sorprendió fue que a mis propios clientes les encantó la página. Varios me dijeron "qué profesional se ve tu negocio". Eso me dio mucha más credibilidad para cerrar trabajos grandes.',
        author: 'Andrés Castillo',
        role: 'Pressure Washing',
        location: 'Orlando, FL',
        timeAgo: 'hace 1 semana',
      },
      {
        quote:
          'Le pusimos el QR de la página en las camionetas y ahora es publicidad gratis rodando por toda la ciudad. La gente escanea el código en los semáforos y nos escriben directo por WhatsApp. Genial.',
        author: 'Luis Hernández',
        role: 'HVAC & Plomería',
        location: 'San Antonio, TX',
        timeAgo: 'hace 2 semanas',
      },
      {
        quote:
          'En la primera semana ya tenía gente preguntando por presupuestos desde la página. Antes andaba pegando flyers y ahora los clientes me encuentran solos. Valió cada dólar de los $250.',
        author: 'Miguel Ángel Soto',
        role: 'Construcción',
        location: 'Las Vegas, NV',
        timeAgo: 'hace 4 días',
      },
    ],
    stats: [
      {
        data: '97%',
        desc: 'de los consumidores busca online antes de contratar',
        meaning: 'Tus clientes te están buscando ahora mismo',
      },
      {
        data: '75%',
        desc: 'nunca pasa de la primera página de Google',
        meaning: 'Si no estás ahí, no existes',
      },
      {
        data: '88%',
        desc: 'de los que buscan en celular contactan en 24 horas',
        meaning: 'Presencia móvil = clientes inmediatos',
      },
      {
        data: '3x',
        desc: 'más confianza generan los websites profesionales',
        meaning: 'Véte premium, consigue clientes premium',
      },
    ],
  },
  guarantee: {
    title: 'Cero Riesgo. 100% Satisfacción.',
    titleHighlight: 'O Lo Corregimos.',
    p1: 'Sabemos que probablemente te han fallado antes.',
    p2: 'Tal vez alguien te hizo un website que no se parecía en nada a lo que querías. Tal vez pagaste y nunca viste resultados.',
    p3: 'Así no operamos nosotros.',
    confidenceBadge: 'Confiamos en nuestro trabajo',
    confidenceA: 'Estamos tan seguros de la calidad de lo que hacemos que',
    confidenceHighlight: 'sabemos que tu página te va a encantar',
    confidenceB:
      '. Por eso te dejamos verla antes de pagarla completa — no necesitamos convencerte con palabras, te lo demostramos con tu propio website.',
    guaranteeTitle: 'Nuestra Garantía:',
    items: [
      {
        promise: 'Solo $25 por tu demo',
        meaning: 'Es todo lo que arriesgas para ver tu website real',
      },
      {
        promise: 'Si no te gusta, ahí termina',
        meaning: 'Solo se te cobra el demo, sin compromiso',
      },
      {
        promise: 'Revisiones incluidas',
        meaning: 'No paramos hasta que lo ames',
      },
      {
        promise: 'Proceso transparente',
        meaning: 'Sabes exactamente qué está pasando en cada etapa',
      },
      {
        promise: 'Comunicación directa por WhatsApp',
        meaning: 'Respuestas rápidas, sin intermediarios',
      },
      {
        promise: 'Sin mensualidades forzadas',
        meaning: 'Pagas el mantenimiento solo si lo quieres',
      },
    ],
    closingA: 'Pagas el resto solo si tu demo te',
    closingHighlight: 'encanta',
    closingB: '. Si no, solo pagaste los $25.',
  },
  urgency: {
    badge: 'Cupos limitados esta semana',
    title:
      'Cada Día Sin Un Website Profesional Es Dinero Que Se Queda En La Mesa',
    p1: 'Ahora mismo, un homeowner en tu área acaba de buscar tu servicio en Google y eligió la opción que se veía más profesional.',
    p2: '¿Eras tú?',
    p3: 'Si no — ese trabajo pudo haber sido tuyo.',
    offerA: 'Por solo',
    offerPrice: '$25 hoy',
    offerB: 'puedes ver tu website antes de decidir.',
    clock: 'Tu website trabajando en menos de 72 horas.',
    cta: 'Apartar Mi Lugar →',
    importantLabel: 'Importante:',
    importantText:
      'trabajamos con un número limitado de clientes por semana para garantizar atención completa y calidad premium en cada website.',
  },
  finalCta: {
    titleA: 'Tu Negocio Hace Un Trabajo Premium.',
    titleHighlight: 'Es Hora De Que Tu Website Lo Demuestre.',
    subtitle:
      'Empieza hoy con solo $25 y mira tu demo real en menos de 72 horas. Si te gusta, pagas el resto. Si no, solo se te cobra el demo. Sin contratos ni mensualidades obligatorias.',
    cardTitle: 'CONTÁCTANOS POR WHATSAPP AHORA',
    cardSub: 'Escríbenos "WEBSITE" y te respondemos hoy',
    checks: [
      'Respuesta rápida',
      'Sin presión ni compromiso',
      'Te explicamos todo en minutos',
      'Empezamos cuando tú estés listo',
    ],
    cta: 'ESCRIBIR POR WHATSAPP AHORA →',
    summaryTitle: 'RESUMEN RÁPIDO DE LA OFERTA',
    rows: [
      {
        label: 'Para empezar solo',
        value: '$25 (tu demo)',
      },
      {
        label: 'Si te gusta, pagas',
        value: '$225 restantes',
      },
      {
        label: 'Si no te gusta',
        value: 'Solo pagas el demo',
      },
      {
        label: 'Website profesional completo',
        value: '$250 en total',
      },
      {
        label: 'Listo en',
        value: 'Menos de 72 horas',
      },
      {
        label: 'Mensualidades obligatorias',
        value: '$0 — No hay',
      },
      {
        label: 'Mantenimiento opcional',
        value: '$30/mes si lo deseas',
      },
      {
        label: 'Contrato largo',
        value: 'No existe',
      },
      {
        label: 'Sorpresas de precio',
        value: 'No existen',
      },
    ],
  },
  faq: {
    title: '¿Tienes Preguntas?',
    titleHighlight: 'Tenemos Respuestas.',
    items: [
      {
        q: '¿Cómo funciona el demo de $25?',
        a: 'Pagas solo $25 y te construimos un demo real de tu website con tu información, tus fotos y tus servicios. Si te gusta, pagas los $225 restantes y lo lanzamos. Si no te gusta, ahí termina — solo se te cobró el demo.',
      },
      {
        q: '¿Cuánto cuesta el website completo?',
        a: '$250 en total. Empiezas con $25 por el demo y los $225 restantes solo los pagas si decides lanzarlo. Sin mensualidades obligatorias ni costos ocultos.',
      },
      {
        q: '¿Los $25 del demo se descuentan del total?',
        a: 'Sí. Los $25 forman parte de los $250 — por eso el resto son solo $225 cuando decides seguir adelante.',
      },
      {
        q: '¿Por qué es tan barato?',
        a: 'Porque nos especializamos solo en contractors y tenemos un proceso súper eficiente: usamos una estructura comprobada que adaptamos a tu negocio, sin agencias caras de por medio ni meses de trabajo. Preferimos cobrar accesible y ganar por volumen y referidos, no inflando el precio. Mismo resultado profesional, sin el costo de una agencia tradicional.',
      },
      {
        q: '¿Cuánto necesito para empezar?',
        a: 'Solo $25. Con eso apartamos tu lugar y construimos el demo de tu website.',
      },
      {
        q: '¿Cuándo pago el resto?',
        a: 'Los $225 restantes los pagas solo cuando veas tu demo terminado y decidas que lo quieres. Nunca antes.',
      },
      {
        q: '¿El dominio está incluido?',
        a: 'Sí, el dominio viene incluido por 1 año. Al terminar ese año se renueva por separado con un costo anual, y te avisamos con tiempo antes de que venza.',
      },
      {
        q: '¿Hay mensualidades?',
        a: 'No hay mensualidades obligatorias. Ofrecemos un plan opcional de mantenimiento por $30/mes si lo deseas.',
      },
      {
        q: '¿Qué incluye el mantenimiento de $30?',
        a: 'Actualización de fotos, cambios de contenido, soporte técnico y comunicación directa por WhatsApp.',
      },
      {
        q: '¿Cuánto tiempo tarda?',
        a: 'Menos de 72 horas una vez que tengamos toda la información de tu negocio.',
      },
      {
        q: '¿Qué información necesitan?',
        a: 'Nombre del negocio, servicios, fotos, número de contacto, área de servicio y cualquier detalle importante.',
      },
      {
        q: '¿Cómo los contacto?',
        a: 'Por WhatsApp al +44 7311 754270 — escríbenos "WEBSITE" y te atendemos hoy.',
      },
      {
        q: '¿Trabajan con todos los contractors?',
        a: 'Sí — roofing, landscaping, tree service, construcción, pressure washing, HVAC, plomería, junk removal y más.',
      },
      {
        q: '¿Qué pasa si no me gusta el diseño?',
        a: 'Primero hacemos revisiones hasta que quede como lo quieres. Y si aun así no te convence, simplemente no pagas el resto — solo se te cobró el demo de $25.',
      },
      {
        q: '¿Necesito saber algo técnico?',
        a: 'Absolutamente no. Nosotros manejamos todo. Tú solo nos das la información y apruebas el resultado.',
      },
    ],
  },
  footer: {
    logoAlt: 'AS Elite Contractor Logo',
    tagline: 'Construido Para Contractors Serios',
    services: 'Servicios',
    portfolio: 'Portafolio',
    about: 'Nosotros',
    reviews: 'Reseñas',
    contact: 'Contacto',
    privacy: 'Política de Privacidad',
    terms: 'Términos de Servicio',
    whatsapp: 'WhatsApp:',
    email: 'Email:',
    tiktok: 'TikTok:',
    copyright: '© 2024 AS Elite Contractor. Todos los Derechos Reservados.',
  },
  legal: {
    close: 'Cerrar',
    lastUpdated: 'Última actualización: 2024 · AS Elite Contractor',
    privacy: {
      title: 'Política de Privacidad',
      sections: [
        {
          heading: '1. Información que recopilamos',
          body: 'Recopilamos la información que nos proporcionas directamente al contactarnos por WhatsApp o formularios, como tu nombre, número de teléfono, nombre del negocio, servicios que ofreces y cualquier material (fotos, textos) necesario para construir tu website.',
        },
        {
          heading: '2. Cómo usamos tu información',
          body: 'Usamos tu información únicamente para crear, entregar y dar mantenimiento a tu website, comunicarnos contigo sobre tu proyecto y, si lo solicitas, gestionar tu perfil de Google Business. No vendemos ni rentamos tu información a terceros.',
        },
        {
          heading: '3. Compartir información',
          body: 'Solo compartimos datos con proveedores estrictamente necesarios para operar tu sitio (por ejemplo, servicios de hosting o dominio). Estos proveedores están obligados a proteger tu información.',
        },
        {
          heading: '4. Seguridad',
          body: 'Tomamos medidas razonables para proteger tu información. Sin embargo, ningún método de transmisión por internet es 100% seguro, por lo que no podemos garantizar seguridad absoluta.',
        },
        {
          heading: '5. Tus derechos',
          body: 'Puedes solicitar acceso, corrección o eliminación de tu información en cualquier momento escribiéndonos por WhatsApp al +44 7311 754270.',
        },
        {
          heading: '6. Cambios a esta política',
          body: 'Podemos actualizar esta política ocasionalmente. La versión más reciente siempre estará disponible en esta página.',
        },
      ],
    },
    terms: {
      title: 'Términos de Servicio',
      sections: [
        {
          heading: '1. Servicio',
          body: 'AS Elite Contractor crea websites profesionales para contractors locales. El servicio inicia con un demo de tu website por $25. Si apruebas el demo, pagas los $225 restantes (total $250) y publicamos el sitio. Si decides no continuar, el único cargo es el demo de $25.',
        },
        {
          heading: '2. Pagos',
          body: 'El pago de $25 por el demo no es reembolsable, ya que cubre el trabajo de diseño realizado. Los $225 restantes se cobran únicamente si apruebas el demo y decides lanzar tu website. Aceptamos pago por Zelle o tarjeta a través de Stripe. No hay mensualidades obligatorias.',
        },
        {
          heading: '3. Dominio',
          body: 'El dominio está incluido por 1 año a partir de la publicación del sitio. Después del primer año, la renovación del dominio se cobra por separado con un costo anual.',
        },
        {
          heading: '4. Tiempo de entrega',
          body: 'Entregamos tu website en menos de 72 horas a partir del momento en que recibimos toda la información necesaria de tu negocio (datos, fotos, servicios y contacto).',
        },
        {
          heading: '5. Revisiones',
          body: 'Incluimos revisiones hasta que estés satisfecho con el diseño. No se requiere el pago final hasta que apruebes el resultado.',
        },
        {
          heading: '6. Mantenimiento opcional',
          body: 'Ofrecemos un plan de mantenimiento opcional de $30/mes que incluye actualización de fotos, cambios de contenido y soporte. Es 100% opcional y puedes cancelarlo cuando quieras.',
        },
        {
          heading: '7. Manejo de perfil de Google',
          body: 'El manejo del perfil de Google Business es un servicio aparte de $30/mes. El perfil debe ser creado por el cliente; nosotros únicamente lo gestionamos y optimizamos.',
        },
        {
          heading: '8. Responsabilidades del cliente',
          body: 'El cliente es responsable de proporcionar información veraz y los materiales necesarios. El cliente es dueño del contenido que entrega y garantiza tener los derechos sobre el mismo.',
        },
        {
          heading: '9. Contacto',
          body: 'Para cualquier duda sobre estos términos, escríbenos por WhatsApp al +44 7311 754270.',
        },
      ],
    },
  },
  promo: {
    cta: 'Quiero el mío →',
    closeLabel: 'Cerrar notificación',
    items: [
      {
        title: 'Carlos M. acaba de ordenar',
        message: 'Su website estará listo en menos de 72 horas.',
      },
      {
        title: 'Cupos limitados esta semana',
        message: 'Solo aceptamos pocos proyectos para entregar rápido.',
      },
      {
        title: 'Tu demo por solo $25',
        message: 'Si te gusta pagas el resto. Si no, solo pagas el demo.',
      },
      {
        title: 'Más clientes encontrándote',
        message: 'Un website profesional te da credibilidad al instante.',
      },
      {
        title: 'Sin contratos ni mensualidades',
        message: 'Un solo pago. Tu website es tuyo para siempre.',
      },
    ],
  },
  floating: {
    title: '¿Listo para tu website?',
    text: 'Escríbenos y te respondemos hoy.',
    aria: 'Contáctanos por WhatsApp',
    closeLabel: 'Cerrar mensaje',
  },
}

export type Translation = typeof es
